// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EmployeeList__titleWrapper>.Title{color:#606060;font-size:1.25rem;margin-bottom:1rem}@media(min-width:768px){.EmployeeList__titleWrapper>.Title{margin-bottom:1.5rem}}@media(min-width:1024px){.EmployeeList__titleWrapper>.Title{text-align:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
